<template>
  <div class="oneui">
    <div>
      <ul class="nameWrapper" :style="`grid-template-columns: 1fr;`">
        <li></li>
        <li class="current">
          <span>{{$t('pages.settings.themes')}}</span>
        </li>
        <li></li>
      </ul>
    </div>
    <div class="pageWrapper">
      <div class="page" style="padding-bottom: 30px">
        <div class="ul">
          <div class="li" v-for="theme in themes" :key="theme" @click="setTheme(theme)">
            <span>{{$t(`pages.settings.themeNames.${theme}`)}}</span>
            <span :class="currentTheme == theme ? 'fhr fhr-circle-check' : 'fhr fhr-circle'"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
/* NPM IMPORTS */
import Parse from "parse";

export default {
  data() {
    return {
      currentTheme: "",
      themes: [
        "sky-blue",
        "vib-cools",
        "soft-cools",
        "peach",
        "light-pumpkin",
        "teal",
        "green",
        "red"
      ]
    };
  },
  watch: {
    mode: function(val) {
      localStorage.setItem("mode", String(val));
    }
  },
  methods: {
    setTheme(className) {
      let user = Parse.User.current();
      user.set("theme", className);
      user.save();
      $("html").attr("theme", className);
      this.currentTheme = className;
    }
  },
  mounted() {
    let _this = this;
    let user = Parse.User.current();
    this.$data.currentTheme = user.get("theme");
  }
};
</script>

